import createVueComponent from '../createVueComponent';

const Eye = createVueComponent('EyeIcon', [
  ['path', { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }],
  ['circle', { cx: '12', cy: '12', r: '3' }],
]);

export default Eye;
